var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',{staticClass:"divAvatarCont",class:_vm.imgClass,attrs:{"src":_vm.comAvatarSrc}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_c('img',{staticClass:"imgGender",attrs:{"src":_vm.comGenderSrc}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }